var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducatorPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_manager_2522727",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.165,
    height: 18.84,
    viewBox: "0 0 17.165 18.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M33.277,67.088c.39-.078.677-.468.859-1.067v-.052a3.381,3.381,0,0,0-1.093-3.331A14.474,14.474,0,0,0,29.3,61.051a.177.177,0,0,0-.208.1L27.682,65.24a.174.174,0,0,1-.312.026L26.225,63.21a.194.194,0,0,1,.026-.234c1.431-1.327.807-2.446-.651-2.576h-.026c-1.457.13-2.056,1.223-.651,2.576a.194.194,0,0,1,.026.234L23.8,65.266a.174.174,0,0,1-.312-.026l-1.405-4.085a.177.177,0,0,0-.208-.1,13.788,13.788,0,0,0-3.721,1.587,3.381,3.381,0,0,0-1.093,3.331v.026c.182.6.442.989.859,1.093l.026.026H33.225A.081.081,0,0,1,33.277,67.088ZM29.5,65.006l1.379-.729a.316.316,0,0,1,.338.026l.963.677H29.5Z",
    transform: "translate(-17.018 -48.274)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M32.841,22.986c.078.1.156.234.286.39a.359.359,0,0,1,.078.1h0c.026.026.052.052.052.078a.025.025,0,0,1,.026.026,5.163,5.163,0,0,0,1.769,1.405,3.064,3.064,0,0,0,3.3-.39,6.022,6.022,0,0,0,1.613-1.952,8.518,8.518,0,0,0,1.093-3.539,4.892,4.892,0,0,0-4.632-5.282c-.026,0-.026-.026-.052-.026h0a4.969,4.969,0,0,0-3.175,1.067,4.9,4.9,0,0,0-1.717,4.424,8.677,8.677,0,0,0,1.353,3.7Zm-.182-3.461a.112.112,0,0,1,.1-.1,2.646,2.646,0,0,0,2.134-1.9.122.122,0,0,1,.208-.026c1.041,1.431,2.186,2.056,4.892,1.952.052,0,.13.052.13.1a5.723,5.723,0,0,1-.677,3.175,4.384,4.384,0,0,1-2.368,2.108,1.791,1.791,0,0,1-.833.078,3.778,3.778,0,0,1-2.42-1.405A5.606,5.606,0,0,1,32.659,19.525Z",
    transform: "translate(-27.694 -13.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducatorPerformance);
export default __webpack_public_path__ + "static/media/educator-performance.ac9f6ddfc3f58ed79926125d093644ff.svg";
export { ForwardRef as ReactComponent };